import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    RemoveAttachmentFromContact as RemoveAttachmentFromContactMutation,
    RemoveAttachmentFromContactVariables,
    ContactFileRemoveInput,
} from 'nutshell-graphql-types';

import REMOVE_ATTACHMENT_FROM_CONTACT from '../mutations/remove-attachment-from-contact.graphql';

export const useRemoveAttachmentFromContact = (): {
    removeAttachmentFromContact: (arg1: ContactFileRemoveInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [removeAttachmentFromContact, {loading, error}] = useMutation<
        RemoveAttachmentFromContactMutation,
        RemoveAttachmentFromContactVariables
    >(REMOVE_ATTACHMENT_FROM_CONTACT);

    return {
        removeAttachmentFromContact: (input: ContactFileRemoveInput) =>
            removeAttachmentFromContact({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
